import {BaseQueryFn} from '@reduxjs/toolkit/query/react';

import {api as AdminApi} from '../../modules/api/useApi';
import {APIError} from '~/modules/api/api.core';
import {AxiosError} from 'axios';

type BaseQueryArgs = {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  data?: any;
};

export const baseQuery: BaseQueryFn<
  BaseQueryArgs,
  unknown,
  {message: string}
> = async (args, api, extraOptions) => {
  try {
    const response = await AdminApi.fetch(args);

    const contentType = (response.headers['content-type']?.toString()) || "application/json"

    if (contentType.includes("application/json")) { 
      if (response.data.status === 'success') {
        return {data: response.data.data};
      } else {
        return {error: {message: response.data.errorMessage}};
      }
    } else {
      return {data: response.data};
    }
  } catch (error) {
    if (error instanceof AxiosError) {
      return {
        error: {message: error.response?.data?.errorMessage ?? error.message},
      };
    } else if (error instanceof APIError) {
      return {error: {message: error.message}};
    } else {
      return {error: {message: (error as Error).message}};
    }
  }
};
